<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <!-- <div class="card-header">
            <div slot="header">
              <div class="row">
                <div class="col-sm-10">
                  <i style="color: #20a8d8;"></i> Company Name
                </div>
              </div>
            </div>
          </div> -->
         
          <div class="card-body">
            <vue-good-table
              mode="remote"
              ref="my-table"
              @on-page-change="onPageChange"
              @on-sort-change="onSortChange"
              @on-column-filter="onColumnFilter"
              @on-per-page-change="onPerPageChange"
              :totalRows="totalRecords"
              :columns="columns4"
              :rows="rows4"
              :pagination-options="{
                enabled: true,
                perPage: 5,
              }"
              styleClass="vgt-table striped bordered table-sm condensed"
            >
              <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'action'">
                  
                  <i
                    class="fa fa-eye"
                    @click="viewCard(props.row)"
                    style="color: #63c2de; font-size: 20px; cursor: pointer;"
                  ></i>
                  
                  
                </span>
                <span v-if="props.column.field == 'created_date'">
                  {{ newDate(props.row.created_date) }}
                </span>
                <span v-else>
                  {{ props.formattedRow[props.column.field] }}
                </span>
              </template>
            </vue-good-table>
          </div>
        </div>
      </div>
    </div>
    <Spinner v-if="loading"></Spinner>
  </div>
</template>

<script>
import Spinner from "../../spinner.vue";
import { VueEditor } from "vue2-editor";
import DatePicker from "vue2-datepicker";
export default {
  name: "Cardlist",
  components: {
    "date-picker": DatePicker,
    Spinner,
  },
  data() {
    return {
      rows: [],
      rows4: [],
      rows5: [],
      todate: "",
      fromdate: "",
      temprow: null,
      warningModal: false,
      warningModal1: false,
      largeModal: false,
      loading: false,
      totalRecords: 0,
      serverParams: {
        columnFilters: {},
        sort: {
          field: "purchase_id",
          type: "asc",
        },
        page: 1,
        perPage: 5,
      },
      serverParams1: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
      serverParams2: {
        columnFilters: {},
        sort: {},
        page: 1,
        perPage: 10,
      },
       columns4: [
        // {
        //   label: "Card Id",
        //   field: "id",
        //   width: "10% !important",
        //   thClass: "text-center",
        // },
        {
          label: "Ledger No",
          field: "ledger_no",
          width: "5% !important",
          thClass: "text-left",
        },
        {
          label: "Scheme Name",
          field: "scheme_name",
          width: "15% !important",
          thClass: "text-left",
        },
         {
          label: "Shop Name",
          field: "company_name",
          width: "15% !important",
          thClass: "text-left",
        },
         {
          label: "Customer Name",
          field: "cust_cmp_name",
          width: "15% !important",
          thClass: "text-left",
        },
        {
          label: "Monthly Pay",
          field: "monthly_pay",
          width: "15% !important",
          thClass: "text-left",
        },
        {
          label: "Opening Month",
          field: "opening_month",
          width: "15% !important",
          thClass: "text-left",
        },
        
        {
          label: "Created Date",
          field: "created_date",
          type: "date",
          dateInputFormat: "YYYY-MM-DDThh:mm:ss",
          dateOutputFormat: "Do MMM YYYY",
          tdClass: "text-left",
          thClass: "text-left",
          width: "15% !important",
        },
          {
          label: "Wallet Amount",
          field: "total_card_amount",
          width: "15% !important",
          thClass: "text-left",
        },
         {
          label: "Status",
          field: "status",
          width: "15% !important",
          thClass: "text-left",
        },
        
        {
          label: "Action",
          field: "action",
          width: "10% !important",
          thClass: "text-left",
          tdClass: "text-left",
        },
      ],
      columns5: [
        // {
        //   label: "Card Id",
        //   field: "id",
        //   width: "10% !important",
        //   thClass: "text-center",
        // },
        {
          label: "Company Name",
          field: "companyname",
          width: "5% !important",
          thClass: "text-left",
          
        },
        {
          label: "Customer Name",
          field: "cust_cmp_name",
          width: "15% !important",
          thClass: "text-left",
        },
               
        // {
        //   label: "Action",
        //   field: "action",
        //   width: "10% !important",
        //   thClass: "text-left",
        //   tdClass: "text-left",
        // },
      ],
    };
  },
  created(){
    //  this.getTotals();
    //  this.getCompany();
      this.showCustCard();
  },
  computed: {
    
  
  },

  methods: {
     getCompany(){
      console.log("Company")
     
      var _this=this
      var data ={
        phoneno:"8792486621"
      }
      this.$http.post('api/customers/customerCompanyAccount',data).then(function (response) {
        if (response.data == null) {
           
          } else {
           console.log(response)
           _this.rows5=  response.data;
          }
        }).catch(function (error) {
       console.log("test")
      });
     },
    searchcard() {
      this.updateParams({
        sort: {
          type: "",
          field: "",
        },
        page: 1,
      });
      this.$refs["my-table"].reset();
      this.getTotals();
    },
    showCustCard(){
      console.log('Show Specific Companies Cards')
      var custDetail =  JSON.parse(localStorage.getItem('cardDetail'))
      console.log(custDetail.company_id)
      // console.log(custDetail.company_id)
      var _this=this
            // localStorage.removeItem("customer_id");
            var customer_id =  localStorage.getItem('authUserid')
            let filteParam = {};
            filteParam.page = this.serverParams.page;
            filteParam.perPage = this.serverParams.perPage;
            filteParam.sort = this.serverParams.sort;
            var data=[];
            this.rows=[];
            this.loading = true
            var data = data+"&filter[where][cusid]=" + custDetail.customer_id;
         data = 
          data +
          "&filter[where][company_id]=" +
          custDetail.company_id +
          "&filter[where][regcity]=" +
          custDetail.regcity_code;
          console.log(data)
            this.$http.get('/api/customercards/showcustomer_card?params='+JSON.stringify(filteParam)+data)
                    .then(function(response){
                       console.log('customer card response')
                       console.log(response)
                       console.log('total records')
                        console.log(response.data[0])
                      _this.totalRecords = response.data[0].totalRecords;
                      console.log( _this.totalRecords)
                      response.data.shift()
                      if(response.data != undefined)
                      _this.rows4=  response.data;
                      // _this.super_user = _this.$store.getters.get_super_user;
                      console.log(_this.super_user)
                      _this.loading = false
                      // console.log(response.data)
                      let wallet = 0.00;
                        for(var i=0; i<response.data.length; i++)
                        {   
                            wallet += parseInt(response.data[i].total_card_amount);
                        }
                        console.log(response.data.length)
                        console.log("total card wallet: " +wallet)
                        localStorage.setItem('authWallet', wallet)
                      }).catch(function(error){
                  console.log(error)
              })
              _this.loading  = false
    },
     viewCard(row) {
      console.log('clicking and row')
      console.log(row)
      this.rows.length = 0;
      let filteParam = {};
      filteParam.page = this.serverParams1.page;
      filteParam.perPage = this.serverParams1.perPage;
      filteParam.sort = this.serverParams1.sort;
      var _this = this;
      this.temprow = row;
      // var comp = 'MUMSAI1';
      // var reg = 'MUM'
      var data = "&filter[where][card_id]=" + row.id;
      // if (this.selectcompany !== null) {
      //   data =
      //     data +
      //     "&filter[where][company_id]="+comp+" &filter[where][regcity]="+reg+"";
      // }
      this.$http
        .get(
          "/api/customercards/srarchpercustomercard?params=" +
            JSON.stringify(filteParam) +
            data
        )
        .then(function (response) {

          if (response.data == null) {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            alert(
              "Card id - " +
                row.id +
                " No Detail Found"
            );
          } else {
            setTimeout(function () {
              _this.loading = false;
            }, 2000);
            _this.$router.props = [row.id];
            localStorage.setItem("card_id", JSON.stringify(row.id));
            

            _this.$router.push("/customercardmonthlydetials");
          }
        });
    },
    newDate(date1) {
      var dt1 = new Date(date1);
      var year = dt1.getFullYear();
      var month = dt1.getMonth() + 1;
      var day = dt1.getDate();
      if (day < 10) {
        day = "0" + day;
      }
      if (month < 10) {
        month = "0" + month;
      }
      var dt2 = day + "-" + month + "-" + year;
      // var dt2 = year+'-'+month+'-'+day
      return dt2;
    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      this.updateParams({ page: params.currentPage });
      // this.loadItems();
      //  this.getTotals();
      this.showCustCard();
    },

    onPerPageChange(params) {
      this.updateParams({ perPage: params.currentPerPage, page: 1 });
      // this.loadItems();
      //  this.getTotals();
      this.showCustCard();
    },

    onSortChange(params) {
      this.updateParams({
        sort: {
          type: params.sortType,
          field: this.columns[params.columnIndex].field,
        },
        page: 1,
      });
      // this.loadItems();
      //  this.getTotals();
      this.showCustCard();
    },

    onColumnFilter(params) {
      this.updateParams(params);
      // this.loadItems();
      //  this.getTotals();
      this.showCustCard();
    },
    getTotals(val){    
      console.log('automatic run')
            if(val === 'comp'){
                if(this.tfrst_time === false){
                  this.tfrst_time = true
                }
                else{
                  return
                }
              }
            var _this=this
            // localStorage.removeItem("customer_id");
             var customer_id =  localStorage.getItem('authUserid')
            var custname = this.selectedcustomer
            let filteParam = {};
            filteParam.page = this.serverParams.page;
            filteParam.perPage = this.serverParams.perPage;
            filteParam.sort = this.serverParams.sort;
            var data=[];
            this.rows=[];
            this.loading = true
            var data = data+"&filter[where][cusid]=" + customer_id;
              
            console.log('hitting pages')
            this.$http.get('/api/customercards/showcustomer_card?params='+JSON.stringify(filteParam)+data)
                    .then(function(response)
                    {
                       console.log('customer card response')
                       console.log(response)
                       console.log('total records')
                        console.log(response.data[0])
                      _this.totalRecords = response.data[0].totalRecords;
                      response.data.shift()
                      if(response.data != undefined)
                      _this.rows4=  response.data;
                      // _this.super_user = _this.$store.getters.get_super_user;
                      console.log(_this.super_user)
                      _this.loading = false
                      // console.log(response.data)
                       
                      }).catch(function(error){
                  console.log(error)
              })
              _this.loading  = false
            },
 
    

 




   
  },
};
</script>



// WEBPACK FOOTER //
// src/views/goldcustomers/customerCardDetails.vue